(() => {
  if (customElements.get("product-grid-item-nosto")) return;

  class ProductGridItemNosto extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.updateLayout();
    }

    async updateLayout() {
      try {
        const productUrl = this.getAttribute("data-url");
        const url = new URL(productUrl);
        const searchParams = url.search.replace("?", "");
        url.searchParams.set("section_id", "product-grid-item");

        const response = await fetch(url.href);
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, "text/html");

        const productItem = doc.querySelector("product-grid-item");
        productItem.querySelectorAll("a").forEach((a) => {
          a.href = a.href.includes("?") ? `${a.href}&${searchParams}` : `${a.href}?${searchParams}`;
        });
        this.outerHTML = productItem.outerHTML;
      } catch (error) {
        this.querySelector('.product-grid-item__images[style*="opacity: 0"]').removeAttribute("style");
      }
    }
  }

  customElements.define("product-grid-item-nosto", ProductGridItemNosto);
})();
